/* global TIRENDO */

/**
* Modularised common.tooltips
* @todo: Underlying implementation still needs refactored
*/
function Tooltip($elm, content, $content, config) {
    'use strict';
    this.$elm              = $elm;
    this.content           = content;
    this.$content          = $content;
    this.$contentContainer = $content.find('.text');
    this.orientation       = ['left', 'up'];
    this.$document         = config.$document || $(document);
    this.$window           = config.$window || $(window);
    this.config            = $.extend({
        hintOnly: false,
        showTrigger: 'mouseenter',
        hideTrigger: 'mouseleave',
        tooltipTemplate: '<i class="fa fa-info-circle tooltip" aria-hidden="true"></i>'
    }, config);
}

Tooltip.prototype = {
    init: function () {
        'use strict';
        this._initContentParts();

        this._initTooltip()
            ._bindShowTrigger()
            ._bindHideTrigger()
            ._bindMouseMoveTrigger();
    },
    _initContentParts: function () {
        'use strict';
        this.$headerLeft  = this.$content.find('header .part.left');
        this.$footerLeft  = this.$content.find('footer .part.left');
        this.$headerRight = this.$content.find('header .part.right');
        this.$footerRight = this.$content.find('footer .part.right');
        this.$allParts    = this.$headerLeft
            .add(this.$footerLeft)
            .add(this.$headerRight)
            .add(this.$footerRight);
    },
    _bindShowTrigger: function () {
        'use strict';
        this.$tooltip.on(this.config.showTrigger, $.proxy(this._showContent, this));
        return this;
    },
    _bindHideTrigger: function () {
        'use strict';
        this.$tooltip.on(this.config.hideTrigger, $.proxy(this._hideContent, this));
        return this;
    },
    _bindMouseMoveTrigger: function () {
        'use strict';
        this.$tooltip.on('mousemove', $.proxy(this._handleMouseMove, this));
        return this;
    },
    _showContent: function (ev) {
        'use strict';

        //Add any custom classes
        //Add our content
        //Reset any previously calculated positioning
        this._addContentClass()
            .addContentToContainer()
            .resetContentContainerStyles();

        this._handleOrientation(ev);
    },

    _hideContent: function () {
        'use strict';

        this.$content.hide();

        if (this.config.cssClass) {
            this.$content.removeClass(this.config.cssClass);
        }
        return this;
    },

    _handleMouseMove: function (ev) {
        'use strict';
        var newOrientation, newOrientationClasses;

        if (!this.orientation) {
            return;
        }

        //this._setContentOrientation(this.orientation);

        newOrientation    = this._calcOrientation(ev);
        newOrientationClasses = this._getClassesFromOrientationConfig(newOrientation);

        //check if need to change the orientation
        if (newOrientationClasses !== this._getClassesFromOrientationConfig(this.orientation)) {
            this.orientation = newOrientation;
        }

        this._setContentOrientation(newOrientation);

        //Position content
        this._positionContent(ev, newOrientationClasses);

        this.$content.addClass(newOrientationClasses).show();
    },

    _getClassesFromOrientationConfig: function (config) {
        'use strict';

        return config.join(' ');
    },

    _positionContent: function (ev, orientationClasses) {
        'use strict';
        var newCSS;


        //Get positioning
        newCSS = $.extend(this._getPositioningFromEvent(orientationClasses, ev), {
            visibility: 'visible'
        });

        //Clear current orientation
        this._removeContentDirectionClasses();

        //display
        this.$content.css(newCSS);
    },

    _getPositioningFromEvent: function (orientation, ev) {
        'use strict';

    switch (orientation) {
        case 'left up':
            var leftPosition = ev.pageX - (this.$content.outerWidth(false) - 36);
            return {left: (leftPosition < 0) ? 0 : leftPosition, top: ev.pageY - (this.$content.outerHeight(false) + 6)            };
        case 'left down':
            var leftPosition = ev.pageX - (this.$content.outerWidth(false) - 36);
            return {left: (leftPosition < 0) ?0:leftPosition, top: ev.pageY + 20};
        case 'right up':
            return {left: ev.pageX - 33, top: ev.pageY - (this.$content.outerHeight(false) + 6)};
        case 'right down':
            return {left: ev.pageX - 33, top: ev.pageY + 20};
        default:
            throw new Error('AppError', 'Unknown tooltip orientation');
        }

    },

    _replaceContentDirectionClasses: function (newClasses) {
        'use strict';
        this.$content.removeClass('left right up down').addClass(newClasses);
    },

    _handleOrientation: function (ev) {
        'use strict';
        this.orientation = this._calcOrientation(ev);
        this._setContentOrientation(this.orientation);
    },

    /**
    * @Todo: Find out why constants 44 || 11 were selcted, make them configuarable
    * Calculate orientation
    */
    _setContentOrientation: function (orientation) {
        'use strict';
        if (!orientation) {
            return;
        }

        this.resetOrientationStyles();

        var directionOffset;

        if (orientation[0] === 'left') {
            directionOffset = 44;
        } else {
            directionOffset = 10;
        }

        this.$headerLeft
            .add(this.$footerLeft)
            .css('width', this._calcContentWidth(directionOffset));
    },


    _calcContentWidth: function (directionOffset) {
        'use strict';
        return this.$content.innerWidth() - directionOffset;
    },
    /**
    * @Todo: Find out why constants 36 || 6 were selcted, make them configuarable
    * Calculate orientation
    */
    _calcOrientation: function (ev) {
        'use strict';
        var orientation = [];

        if (this.config.cssClass === "cartDataTooltip" /** huck for shopping cart*/) {
            orientation.push('left');
            orientation.push('down');
        } else {
            if ((ev.pageX + (this.$content.outerWidth(false) - 36) - this.$document.scrollLeft()) > this.$window.width()) {
                orientation.push('left');
            } else {
                orientation.push('right');
            }

            if ((ev.pageY - (this.$content.outerHeight(false) + 6) - this.$document.scrollTop()) > 0) {
                orientation.push('up');
            } else {
                orientation.push('down');
            }
        }

        return orientation;
    },

    _addContentClass: function () {
        'use strict';
        if (this.config.cssClass) {
            this.$content.addClass(this.config.cssClass);
        }
        return this;
    },

    _removeContentDirectionClasses: function () {
        'use strict';
        this.$content.removeClass('left right up down');
    },

    _initTooltip: function () {
        'use strict';

        if (this.$tooltip) {
            return this;
        }

        if (this.config.hintOnly) {
            this.$tooltip = this.$elm;
        }
        else {
            this.$tooltip = $(this.config.tooltipTemplate);
            this._addTooltipToElm();
        }

        return this;
    },

    addContentToContainer: function () {
        'use strict';
        this.$contentContainer.html(this.content);
        return this;
    },
    _addTooltipToElm: function () {
        'use strict';
        this.$elm.append(this.$tooltip);
        return this;
    },

    resetContentContainerStyles: function () {
        'use strict';
        this.$content.css({
            visibility : 'hidden',
            left       : 0,
            top        : 0
        });
        return this;
    },
    resetOrientationStyles: function () {
        'use strict';
        this.$allParts.removeAttr('style');
        return this;
    },

    updateContent: function (content) {
        'use strict';
        this.content = content;
    }
};


//Init standard tooltips, and cache in namespace
(function autoInitTooltips(namespace) {
    'use strict';


    var initTooltips = function () {
        var $tooltipLayer = $('#tooltipLayer');
        if (!$tooltipLayer.length) {
            $("body").append("<div id='tooltipLayer'><table class='content'><tbody><tr><td><a class='close_btn'>x</a></td></tr><tr><td class='text'></td></tr></tbody></table></div>");

            if(IsMobile.any()) {
                var $tooltipCloseButton = $("a.close_btn");
                $tooltipCloseButton.css("display", "block");

                $tooltipCloseButton.on('click', function(event) {
                    $tooltipLayer.hide();
                    event.stopPropagation();
                });
            }
        }
        var $content = $('#tooltipLayer');
        $('[data-tooltip]:not([data-tooltip-ref])').each(function (ind) {
            var $tt = $(this);
            var conf = {
                hintOnly : $tt.data('hint'),
                cssClass : $tt.data('tooltip-class') || false
            };

            $tt.attr('data-tooltip-ref', ind);
            $tt.data('tooltip-ref', ind);

            var tt = new Tooltip($tt, $tt.data('tooltip'), $content, conf);
            tt.init();
            namespace.tooltips[ind] = tt;
        });
    };

    namespace.tooltips = {};
    namespace.initTooltips = initTooltips;

    $(initTooltips);

})(THEME);